import React, {useCallback, useEffect, useRef, useState} from "react";
import withData from "src/core/data-sources/decorators/withData";
import OrdersListDataSource from "../data-sources/ordersList";
import styled from "styled-components";
import Loader from "../../common/components/elements/Loader";
import {OrderCard} from "./OrderCard";
import EmptyPlaceholder from "../../common/components/elements/placeholder/EmptyPlaceholder";
import useRouter from "../../common/hooks/useRouter";
import routes from "../../common/routes";
import {LoaderContainer} from "../../common/components/modules/modal/modalComponents";
import InfiniteScroll from "react-infinite-scroller";
import {Section} from "../../common/components/elements/container/section";
import usePagination from "src/core/common/hooks/pagination/usePagination";
import PaginationContext from "src/core/common/hooks/pagination/context";
import useInfinitePagination from "src/core/common/hooks/pagination/useInfinitePagination";

let BaseOrdersList = (props) => {
  const {orders, order, onListUpdate, meta, render} = props;

  /* eslint-disable */
  const getCurrentResponse = useCallback(() => {
    return {...props, elements: orders ? orders.getElements() : []};
  }, [orders]);
  /* eslint-enable */

  const {manager, setPage} = usePagination();
  const [previousResponse, setPreviousResponse] = useState(getCurrentResponse());
  const [_orders, setOrders] = useState(orders ? orders.getElements() : []);

  /* eslint-disable */
  useEffect(() => {
    const currentResponse = getCurrentResponse();
    const elements = manager.getResponse(previousResponse, currentResponse, _orders);
    setOrders(elements);
    setPreviousResponse(currentResponse);
    if (onListUpdate) {
      onListUpdate(orders);
    }
  }, [onListUpdate, orders]);
  /* eslint-enable */

  /* eslint-disable */
  useEffect(() => {
    setPage(1)
  }, [order]);
  /* eslint-enable */

  return render({
    meta: {...meta, loading: meta.loading},
    orders: _orders,
    order,
    showLoading: meta.loading,
  });
};

BaseOrdersList = withData(
  {
    dataSource: new OrdersListDataSource(),
    keyFields: ["limit", "offset", "order", "filters", "search"],
    dataField: "orders",
  },
  BaseOrdersList
);

/**
 * @return {boolean}
 */
function OrdersList({className, orders, order, meta, showLoading}) {
  const {manager, setPage} = usePagination();
  const [isRequesting, setRequesting] = useState(false);
  const router = useRouter();
  const containerRef = useRef();

  const loadMore = useCallback(() => {
    if (!isRequesting) {
      setPage(manager.page + 1);
      setRequesting(true);
    }
  }, [manager, setPage, isRequesting]);

  useEffect(() => {
    setRequesting(false);
  }, [orders.length]);

  useEffect(() => {
    if (containerRef.current && manager.page === 1) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [manager.page, order]);

  return (
    <>
      {orders.length > 0 || showLoading ? (
        <Section
          ref={containerRef}
          style={{height: "100%", width: "100%", overflow: "auto"}}
        >
          <InfiniteScroll
            initialLoad={false}
            loadMore={loadMore}
            hasMore={manager && manager.hasMorePages()}
            useWindow={false}
            loader={
              <LoaderContainer key={"loader"}>
                <Loader />
              </LoaderContainer>
            }
          >
            <OrdersListContainer
              className={className}
              loading={Boolean(meta.loading) ? "true" : undefined}
            >
              {orders.map((order, index) => (
                <li key={index}>
                  <OrderCard order={order} />
                </li>
              ))}
            </OrdersListContainer>
          </InfiniteScroll>
        </Section>
      ) : (
        <EmptyPlaceholder
          title={"You haven’t placed any orders"}
          buttonText={"Check our products"}
          action={() => {
            router.push(routes.home);
          }}
        />
      )}
    </>
  );
}

const OrdersListContainer = styled.ul`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  opacity: ${({loading}) => (loading ? 0.5 : 1)};
  > * {
    width: 100%;
    margin-bottom: ${({theme}) => theme.v2.spacing(8)};
    padding-bottom: ${({theme}) => theme.v2.spacing(8)};
    &:not(:last-child) {
      border-bottom: 0.5px solid ${({theme}) => theme.v2.color.base.grey["100"]};
    }
  }
`;

function OrdersListWrapper({filters, order, ...props}) {
  const [ordersPage, setOrdersPage] = useState(null);
  const totalPages = ordersPage ? ordersPage.getTotalPages() : 1;
  const [manager, setPage] = useInfinitePagination({limit: 25, totalPages});
  const onListUpdate = useCallback(
    function (orders) {
      setOrdersPage(orders);
    },
    [setOrdersPage]
  );
  return (
    <PaginationContext.Provider value={{manager, setPage}}>
      <BaseOrdersList
        offset={manager.offset}
        limit={manager.limit}
        onListUpdate={onListUpdate}
        filters={filters}
        order={order}
        render={({showLoading, orders, meta, order}) => (
          <OrdersList
            {...props}
            showLoading={showLoading}
            order={order}
            orders={orders}
            meta={meta}
          />
        )}
      />
    </PaginationContext.Provider>
  );
}
export default OrdersListWrapper;
